import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { QuestionsProps } from './Questions.tsx';

export const LazyQuestions: LoadableType<QuestionsProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Questions" */ './Questions.tsx')).Questions,
});
